import AccountIconWh104 from '../../../components/atoms/account_icons/AccountIconWh104'
import Ticket from '../../../components/atoms/tickets/Ticket'
export default {
  components: { AccountIconWh104, Ticket },
  data() {
    return {
      checkedItemKeys: [],
      ticketItemValues: [],
      checkedAllItems: false
    }
  },
  mounted() {
    // 表示される ticket の checkbox の value を取得して、this.ticketItemValues にセットする
    // 全選択のチェックボックスによる全選択と全選択解除を実装するため
    // 将来的に SPA にした場合は非同期でサーバーから値を取得して動的に checkbox を生成するようにしたい
    const ticketCheckboxes = document.querySelectorAll(
      ".ticket-checkbox input[type='checkbox']"
    )
    ticketCheckboxes.forEach((_, index) => {
      const ticketCheckboxHtml = ticketCheckboxes[index].outerHTML.match(
        /value="(.*?)"/
      )
      this.ticketItemValues.push(ticketCheckboxHtml[1])
    })
  },
  computed: {
    isSubmittable() {
      return this.checkedItemKeys.length !== 0
    }
  },
  methods: {
    check(id) {
      if (this.checkedItemKeys.includes(id)) {
        this.checkedItemKeys = this.checkedItemKeys.filter(n => n !== id)
      } else {
        this.checkedItemKeys.push(id)
      }
      this.checkedAllItems =
        this.checkedItemKeys.length === this.ticketItemValues.length
    },
    checkAll() {
      if (this.checkedItemKeys.length === this.ticketItemValues.length) {
        this.checkedItemKeys = []
        this.checkedAllItems = false
      } else {
        this.checkedItemKeys = []
        this.checkedAllItems = true
        this.ticketItemValues.forEach(value => {
          this.check(Number(value))
        })
      }
    }
  }
}
